/**
 * Scopes passed to `FB.login()` for Instagram, Pages, creator marketplace,
 * Partnership Ads (Meta Marketing API), and Creator Marketplace Messaging.
 * The ads_* / branded_content_* / catalog scopes drive partnership-ad creation;
 * instagram_creator_marketplace_messaging + pages_read_user_content drive brand
 * -> creator Partnership-folder messaging (both require Meta App Review).
 */
export const FACEBOOK_LOGIN_SCOPE =
  "instagram_basic,instagram_manage_messages,business_management,pages_show_list,pages_read_engagement,pages_read_user_content,instagram_manage_insights,instagram_manage_comments,pages_manage_metadata,instagram_creator_marketplace_discovery,instagram_creator_marketplace_messaging,ads_management,ads_read,instagram_branded_content_ads_brand,instagram_branded_content_creator,catalog_management";
